export class Interview {
    title;
    questions;
    attempts;
    student;
    question_id: string;
    constructor(title, questions, attempts, student) {
        this.title = title;
        this.questions = questions;
        this.attempts = attempts;
        this.student = student;
    }

    get studentInterview() {
        return this.student._id;
    }
}
